import axios, { AxiosResponse } from 'axios';
import getApiBaseUrl from '../GetServer';
import { Blog } from './GetPublicBlogs';

// Interface for the request body, matching the C# backend model
interface GetLastBlogByTitleRequest {
  Title: string;
}

// Interface for the API response
interface BlogResponse {
  status: number;
  message: string;
  data: Blog;
}

export const GetLastBlogByTitle = async (title: string): Promise<Blog> => {
  if (!title) {
    throw new Error("El título es un campo obligatorio.");
  }

  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}blog/get-last-blog`;

    const requestBody: GetLastBlogByTitleRequest = {
      Title: title,
    };

    const response: AxiosResponse<BlogResponse> = await axios.post(
      endpoint,
      requestBody,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (response.data.status !== 200) {
      throw new Error(response.data.message || 'Ocurrió un error al obtener el blog.');
    }

    return response.data.data;

  } catch (error) {
    console.error(`Error al obtener el último blog por título "${title}":`, error);

    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message || 'No se pudo cargar el blog desde el servidor.');
    }

    if (error instanceof Error) {
        throw error;
    }

    throw new Error('Ocurrió un error inesperado al intentar obtener el blog.');
  }
};
